import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api/axios";

const empty = { name: "", slug: "", description: "", spec: "", price: "", category: "", stock: "", brand: "", images: "" };

export default function ProductForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(empty);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/categories").then((res) => setCategories(res.data));
    if (id) {
      api.get("/products/by-id/" + id).catch(() => {});
    }
  }, [id]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...form,
      price: Number(form.price),
      stock: Number(form.stock),
      images: form.images ? form.images.split(",").map((s) => s.trim()) : [],
      slug: form.slug || form.name.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
    };
    if (id) {
      await api.put(`/products/${id}`, payload);
    } else {
      await api.post("/products", payload);
    }
    navigate("/admin");
  };

  return (
    <div className="max-w-xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="font-display font-semibold text-2xl mb-8">{id ? "Edit" : "New"} product</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input name="name" placeholder="Name" value={form.name} onChange={handleChange} required
          className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm outline-none" />
        <textarea name="description" placeholder="Description" value={form.description} onChange={handleChange} required
          className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm outline-none" rows={3} />
        <input name="spec" placeholder="Spec (e.g. 65W GaN III)" value={form.spec} onChange={handleChange}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm outline-none" />
        <div className="grid grid-cols-2 gap-4">
          <input name="price" type="number" step="0.01" placeholder="Price" value={form.price} onChange={handleChange} required
            className="bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm outline-none" />
          <input name="stock" type="number" placeholder="Stock" value={form.stock} onChange={handleChange} required
            className="bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm outline-none" />
        </div>
        <select name="category" value={form.category} onChange={handleChange} required
          className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm outline-none">
          <option value="">Select category</option>
          {categories.map((c) => <option key={c._id} value={c._id}>{c.name}</option>)}
        </select>
        <input name="brand" placeholder="Brand" value={form.brand} onChange={handleChange}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm outline-none" />
        <input name="images" placeholder="Image URLs, comma separated" value={form.images} onChange={handleChange}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm outline-none" />
        <button className="w-full bg-accent hover:bg-orange-500 text-black font-semibold rounded-full py-3 text-sm transition">
          Save product
        </button>
      </form>
    </div>
  );
}
